import * as actionLabels from '../../actionLabels';

export const getPropertyList = payload => ({
  type: actionLabels.GET_PROPERTY_LIST,
  payload,
});

export const getPropertyListStart = payload => ({
  type: actionLabels.GET_PROPERTY_LIST_START,
  payload,
});

export const getPropertyListSuccess = payload => ({
  type: actionLabels.GET_PROPERTY_LIST_SUCCESS,
  payload,
});

export const getPropertyListFail = payload => ({
  type: actionLabels.GET_PROPERTY_LIST_FAIL,
  payload,
});

export const createPropertyStat = () => ({
  type: actionLabels.CREATE_PROPERTY_START,
});

export const createProperty = payload => ({
  type: actionLabels.CREATE_PROPERTY,
  payload,
});

export const createPropertySuccess = payload => ({
  type: actionLabels.CREATE_PROPERTY_SUCCESS,
  payload,
});

export const createPropertyFail = payload => ({
  type: actionLabels.CREATE_PROPERTY_FAIL,
  payload,
});

export const mintProperty = payload => ({
  type: actionLabels.MINT_PROPERTY,
  payload,
});

export const mintPropertyStart = () => ({
  type: actionLabels.MINT_PROPERTY_START,
});

export const mintPropertySuccess = payload => ({
  type: actionLabels.MINT_PROPERTY_SUCCESS,
  payload,
});

export const mintPropertyFail = payload => ({
  type: actionLabels.MINT_PROPERTY_FAIL,
  payload,
});

export const putOnSale = payload => ({
  type: actionLabels.PUT_ON_SALE,
  payload,
});

export const buyEquity = payload => ({
  type: actionLabels.BUY_EQUITY,
  payload,
});

export const deleteProperty = payload => ({
  type: actionLabels.DELETE_PROPERTY,
  payload,
});

export const deletePropertyStart = payload => ({
  type: actionLabels.DELETE_PROPERTY_START,
  payload,
});

export const deletePropertySuccess = payload => ({
  type: actionLabels.DELETE_PROPERTY_SUCCESS,
  payload,
});

export const deletePropertyFail = payload => ({
  type: actionLabels.DELETE_PROPERTY_FAIL,
  payload,
});

export const togglePropertyHide = payload => ({
  type: actionLabels.TOGGLE_PROPERTY_HIDE,
  payload,
});

export const togglePropertyHideStart = () => ({
  type: actionLabels.TOGGLE_PROPERTY_HIDE_START,
});

export const togglePropertyHideSuccess = payload => ({
  type: actionLabels.TOGGLE_PROPERTY_HIDE_SUCCESS,
  payload,
});

export const togglePropertyHideFail = payload => ({
  type: actionLabels.TOGGLE_PROPERTY_HIDE_FAIL,
  payload,
});

export const updatePropertyStatus = payload => ({
  type: actionLabels.UPDATE_PROPERTY_STATUS,
  payload,
});

export const updatePropertyStatusStart = () => ({
  type: actionLabels.UPDATE_PROPERTY_STATUS_START,
});

export const updatePropertyStatusSuccess = payload => ({
  type: actionLabels.UPDATE_PROPERTY_STATUS_SUCCESS,
  payload,
});

export const updatePropertyStatusFail = payload => ({
  type: actionLabels.UPDATE_PROPERTY_STATUS_FAIL,
  payload,
});

export const deletePropertyAdditionalDocument = payload => ({
  type: actionLabels.DELETE_PROPERTY_ADDITIONAL_DOCUMENT,
  payload,
});

export const deletePropertyAdditionalDocumentStart = () => ({
  type: actionLabels.DELETE_PROPERTY_ADDITIONAL_DOCUMENT_START,
});

export const deletePropertyAdditionalDocumentSuccess = payload => ({
  type: actionLabels.DELETE_PROPERTY_ADDITIONAL_DOCUMENT_SUCCESS,
  payload,
});

export const deletePropertyAdditionalDocumentFail = payload => ({
  type: actionLabels.DELETE_PROPERTY_ADDITIONAL_DOCUMENT_FAIL,
  payload,
});

export const addPropertyAdditionalDocument = payload => ({
  type: actionLabels.ADD_PROPERTY_ADDITIONAL_DOCUMENT,
  payload,
});

export const addPropertyAdditionalDocumentStart = () => ({
  type: actionLabels.ADD_PROPERTY_ADDITIONAL_DOCUMENT_START,
});

export const addPropertyAdditionalDocumentSuccess = payload => ({
  type: actionLabels.ADD_PROPERTY_ADDITIONAL_DOCUMENT_SUCCESS,
  payload,
});

export const addPropertyAdditionalDocumentFail = payload => ({
  type: actionLabels.ADD_PROPERTY_ADDITIONAL_DOCUMENT_FAIL,
  payload,
});